import { COLORS } from 'helpers/constants';

const AbilityButton = (scene, tile, piece, equippedItem) => {
  const container = scene.add.container();

  let itemSprite = scene.add.sprite(
    8,
    23.5,
    'small_items',
    equippedItem.miniSpriteIndex
  );
  container.add(itemSprite);

  return container;
};

export default AbilityButton;

export const GlobalAbilityButton = scene => {
  const container = scene.add.container();
  container.setDepth(55);
  let activeContainer = scene.add.container().setAlpha(0);
  let inactiveContainer = scene.add.container();
  container.add(activeContainer);
  container.add(inactiveContainer);
  let activeCancelButton,
    itemFrame,
    activeCancelButtonHover,
    activeControllerButtonIndicator,
    inactiveControllerButtonIndicator;

  let itemSprite;

  container.active = false;

  container.setItem = (equippedItem, piece) => {
    // console.log('set Item:', { equippedItem, active });
    container.removeAll(true);
    activeContainer = scene.add.container().setAlpha(0);
    inactiveContainer = scene.add.container();
    container.add(activeContainer);
    container.add(inactiveContainer);

    itemSprite = scene.add.sprite(
      8,
      23.5,
      'small_items',
      equippedItem.miniSpriteIndex
    );

    container.setStateInactive = () => {
      container.active = false;
      activeContainer.setAlpha(0);
      inactiveContainer.setAlpha(1);
      if (equippedItem.preMoveButton) {
        const { cancel } = equippedItem.preMoveButton;
        piece.itemActive = false;
        cancel && cancel(scene, piece.tile);
      }
    };

    const toggleActiveState = () => {
      if (equippedItem.preMoveButton) {
        container.active = !container.active;
        activeContainer.setAlpha(container.active ? 1 : 0);
        inactiveContainer.setAlpha(container.active ? 0 : 1);
        const { action, cancel } = equippedItem.preMoveButton;
        if (container.active) {
          piece.itemActive = true;
          action && action(scene, piece.tile);
        } else {
          piece.itemActive = false;
          cancel && cancel(scene, piece.tile);
        }
      }
    };

    const setCancelDefault = () => {
      activeCancelButton.setAlpha(1);
      activeCancelButtonHover.setAlpha(0);
    };

    const setCancelHover = () => {
      activeCancelButton.setAlpha(0);
      activeCancelButtonHover.setAlpha(1);
    };

    const setFrameHover = () => {
      itemFrame.setFrame(1);
    };

    const setFrameDefault = () => {
      itemFrame.setFrame(0);
    };

    if (equippedItem.preMoveButton && piece.color === 'blue') {
      //inactive state
      //item frame
      itemFrame = scene.add
        .sprite(8, 24, 'ui_item_frame')
        .setInteractive()
        .on('pointerup', toggleActiveState)
        .on('pointerover', setFrameHover)
        .on('pointerout', setFrameDefault);
      inactiveContainer.add(itemFrame);
      inactiveContainer.add(itemSprite);

      const { label } = equippedItem.preMoveButton;

      const labelWidth = label.length * 6;
      const halfWidth = Math.round(labelWidth / 2);

      //active state
      let activeItemSprite = scene.add.sprite(
        -7.5 - halfWidth,
        27.5,
        'small_items',
        equippedItem.miniSpriteIndex
      );
      let activeFrame = scene.add
        .sprite(-7 - halfWidth, 28, 'ui_item_active_lcap')
        .setInteractive()
        .on('pointerup', toggleActiveState)
        .on('pointerover', setCancelHover)
        .on('pointerout', setCancelDefault);
      activeContainer.add(activeFrame);
      activeContainer.add(activeItemSprite);

      for (let i = 0; i < labelWidth; i++) {
        let activeBg = scene.add
          .sprite(3 - halfWidth + i, 28, 'ui_item_active_center')
          .setInteractive()
          .on('pointerup', toggleActiveState)
          .on('pointerover', setCancelHover)
          .on('pointerout', setCancelDefault);
        activeContainer.add(activeBg);
      }

      activeCancelButton = scene.add
        .sprite(8 + halfWidth, 28, 'ui_item_active_rcap')
        .setAlpha(0)
        .setInteractive()
        .on('pointerup', toggleActiveState)
        .on('pointerover', setCancelHover)
        .on('pointerout', setCancelDefault);
      activeCancelButtonHover = scene.add
        .sprite(8 + halfWidth, 28, 'ui_item_active_rcap_hover')
        .setInteractive()
        .on('pointerup', toggleActiveState)
        .on('pointerover', setCancelHover)
        .on('pointerout', setCancelDefault);
      activeContainer.add(activeCancelButton);
      activeContainer.add(activeCancelButtonHover);
      // text
      const textLabel = scene.add
        .text(4, 28, equippedItem.preMoveButton.label, {
          fontSize: `8px`,
          color: COLORS.LIGHT_YELLOW,
          fontFamily: 'pixelMix'
        })
        .setOrigin(0.5)
        .setResolution(10);
      activeContainer.add(textLabel);

      //controller button
      inactiveControllerButtonIndicator = scene.add
        .sprite(20, 36, 'ui_controller_buttons_xsm', 3)
        .setOrigin(1)
        .setAlpha(scene.game.controllerInput ? 1 : 0);
      activeControllerButtonIndicator = scene.add
        .sprite(44, 42, 'ui_controller_buttons_xsm', 3)
        .setOrigin(1)
        .setAlpha(scene.game.controllerInput ? 1 : 0);
      activeContainer.add(activeControllerButtonIndicator);
      inactiveContainer.add(inactiveControllerButtonIndicator);

      container.updateControllerActive = scene => {
        if (scene.game.controllerInput) {
          inactiveControllerButtonIndicator.setAlpha(1);
          activeControllerButtonIndicator.setAlpha(1);
        } else {
          inactiveControllerButtonIndicator.setAlpha(0);
          activeControllerButtonIndicator.setAlpha(0);
        }
      };

      container.XPressed = toggleActiveState;
    } else {
      container.add(itemSprite);
    }
  };

  return container;
};
